<div class="grid grid-cols-2 gap-5">

    <div class="bg-white border rounded-lg">
        <p class="px-5 py-3 font-semibold capitalize">flashcard Performance</p>
        <hr>
        <div class="p-5 ">
            <app-pie-chart [height]="200"></app-pie-chart>
        </div>
    </div>

    <div class="bg-white border rounded-lg">
        <p class="px-5 py-3 font-semibold capitalize">AI test Performance</p>
        <hr>
        <div class="p-5 ">
            <app-pie-chart [height]="200"></app-pie-chart>
        </div>
    </div>

</div>

<div class="w-full  bg-white border rounded-lg py-2 my-5">

    <div>
        <div role="tablist" class="tabs tabs-bordered px-3 capitalize">
            @for (i of tabs; track $index) {
                <a role="tab" (click)="currentTab = i.value" class="tab hover:rounded-t-md" [ngClass]="{'tab-active': currentTab == i.value}">{{i.name}}</a>
            }
          </div>
    </div>

    <div class="p-5">
        <div>
            <ng-container [ngSwitch]="currentTab">
                <app-flashcard-graph *ngSwitchCase="'flashcard'"></app-flashcard-graph>
                <app-ai-test-graph *ngSwitchCase="'ai-test'"></app-ai-test-graph>
                <app-oral-test-graph *ngSwitchCase="'oral-test'"></app-oral-test-graph>
                <app-progress-test-graph *ngSwitchCase="'progress-test'"></app-progress-test-graph>
                <app-live-test-graph *ngSwitchCase="'live-test'"></app-live-test-graph>

            </ng-container>
        </div>
        <hr class="my-5">
        <div>
            <app-table-view [data]="tableData"></app-table-view>
        </div>
    </div>
    
</div>

<div class="w-full bg-white border rounded-lg">
    <div class="px-5 py-3">
     <p class="font-semibold">Certicates</p>
    </div>
    <hr>
    <ul class="flex gap-5 overflow-x-auto p-5">
        @for (i of certifacates; track $index) {
            <li class="">
                <img class="bg-slate-300 h-[12rem] max-w-[18rem] object-contain" src="{{i.img}}" alt="">
                <p class="font-semibold line-clamp-1 mt-3">{{i.title}}</p>
                <div class="flex justify-between items-center">
                    <p class="text-xs text-black capitalize font-semibold">{{i.issued_by}}</p>
                    <p class="text-xs text-zinc-500 uppercase">{{i.date_issued | date}}</p>
                </div>
            </li>
        }
    </ul>
 </div>
